'use client';

import { Suspense } from 'react';
import ContentLoader from 'react-content-loader';
import { ProSectionCTA } from './ProSectionCTA';
import { ProPlanId } from '../../../../constants/premium';

const LoginButtonFallback = ({ id }: { id: string }) => {
  return (
    <div className="size-full" aria-label="log in to Fishbrain">
      {/* Log in */}
      <ContentLoader
        uniqueKey={`${id}-loader`}
        aria-label="Loading Pro button"
        className="flex h-[35px] w-full sm:w-[246px]"
        speed={2}
      >
        <rect x="0" y="0" width="100%" height="100%" />
      </ContentLoader>
    </div>
  );
};

export const SuspendedProSectionCTA = ({
  partnerFlow,
  proPlanId,
  id,
}: {
  partnerFlow?: boolean;
  proPlanId?: ProPlanId;
  id: string;
}) => {
  return (
    <Suspense fallback={<LoginButtonFallback id={id} />}>
      <ProSectionCTA partnerFlow={partnerFlow} proPlanId={proPlanId} />
    </Suspense>
  );
};
